import React from 'react';
import styles from './selling-offers-skeleton.module.scss';

const SellingOffersNegotiationCardSkeleton: React.FC = () => {
  return (
    <div className={`${styles.sellingOffersSkeleton__negotiationCard} ssc`}>
      <div className={styles.sellingOffersSkeleton__negotiationCard__top}>
        <div className={styles.sellingOffersSkeleton__negotiationCard__profile}>
          <div className={styles.sellingOffersSkeleton__negotiationCard__img}>
            <div className="ssc-circle"></div>
          </div>

          <div className={styles.sellingOffersSkeleton__negotiationCard__details}>
            <div className="ssc-line"></div>
          </div>
        </div>
        <div className={styles.sellingOffersSkeleton__negotiationCard__tag}>
          <div className="ssc-line"></div>
        </div>
      </div>

      <div className={styles.sellingOffersSkeleton__negotiationCard__bottom}>
        <div className={styles.sellingOffersSkeleton__negotiationCard__status}>
          <div className="ssc-line w-90"></div>
          <div className="ssc-line w-70"></div>
        </div>

        <div className={styles.sellingOffersSkeleton__negotiationCard__cta}>
          <div className="ssc-head-line"></div>
        </div>
      </div>
    </div>
  );
};

export default SellingOffersNegotiationCardSkeleton;
